export const scmUpdateRespondDetails = (type, details) => ({
    type: type,
    //"SCM_UPDATE_RESPONDED_DETAILS",
    payload: details,
  });
  
  export const scmUpdateothereRespondedDetails = (type, details) => ({
    type: type,
    //"SCM_UPDATE_OTHER_RESPONDED_DETAILS",
    payload: details,
  });
  
  export const scmUpdateCompletionInfoDetails = (type, details) => ({
    type: type,
    //"SCM_UPDATE_COMPLETION_DETAILS",
    payload: details,
  });
  
  export const scmAddRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"SCM_ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
    payload: details,
  });
  
  export const scmUpdateRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"SCM_UPDATE_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
    payload: details,
  });
  
  export const scmAddPartReplacementDetailsForVendor = (type, details) => ({
    type:type,
    //"SCM_PART_REPLACEMENT_FOR_VENDOR",
    payload: details,
  });
  
  export const scmUpdatePartReplacementDetailsForVendor = (type, details) => ({
    type: type,
    //"SCM_UPDATE_PART_REPLACEMENT_FOR_VENDOR",
    payload: details,
  });
  
  export const scmClearPartRepalacementForVendor = (type, details) => ({
    type: type,
    //"SCM_CLEAR_PART_REPLACEMENT_FOR_VENDOR",
    payload: details,
  });
  
  export const scmDeleteRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"SCM_DELETE_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
    payload: details,
  });
  
  export const scmClearRepairTrackerForVendor = (type, details) => ({
    type: type,
    //"SCM_CLEAR_REPAIR_TRACKER_FOR_VENDOR",
    payload: details,
  });
  
  
  export const scmCheckFormSubmitForVendor = (type, details) => ({
    type: type,
    //"SCM_UPDATE_FORMSUBMIT_STATUS",
    payload: details,
  });
  
  export const scmClearWebForm = (type, details) => ({
    type: type,
    //"SCM_CLEAR_WEB_FORM",
    payload: details,
  });
  
  export const getSCMVendorName = (type, details) => ({
    type: type,
    //"GET_SCM_VENDORNAME",
    payload: details,
  });
  